export enum SortOption {
  Newest = 'newest',
  Oldest = 'oldest',
  OpenFirst = 'open_first',
  DoneFirst = 'done_first',
}
